import { Skeleton, Grid } from '@mui/material';
import { useMemo } from 'react';

const SearchLoaderSkeleton = () => {
  const skeletonItems = Array(10).fill(null).map((_, i) => i);
  const renderSkeletonItems = useMemo(() => (skeletonItems.map((item) => (
    <Grid
      item
      lg={6}
      key={`skeleton-${item}`}
    >
      <Skeleton
        variant='rounded'
        height={250}
      />
    </Grid>
  ))), []);

  return (
    <Grid
      container
      spacing={3}
    >
      {renderSkeletonItems}
    </Grid>
  );
};

export default SearchLoaderSkeleton;
